import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Backdrop from '@mui/material/Backdrop';
import CloseIcon from '@mui/icons-material/Close';
import { connect } from 'react-redux';
import { mapStateToProps } from './models/buscar';
import TransferList from './InicioFunctions/transferList';
import { Box, Modal } from '@mui/material';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  borderRadius: 3,
  boxShadow: 24,
  p: 4,
};


const BootstrapDialogTitle = (props) => {
  
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 4, p: 4 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 20,
            top: 20,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

function CustomizedDialogs(props) {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
       <Button variant="outlined" onClick={handleClickOpen} 
      style={{borderWidth: 1, width: 0, borderColor: 'rgba(229, 29, 29, 0.7)', color: 'rgba(229, 29, 29, 0.7)'}}>
        <p style={{ fontSize: 10 }}>Anexos</p>
      </Button>
      <Modal /* style={{ width:800, height: 400 , display: 'flex',  justifyContent: 'center'  }} */
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 250,
      }}
        onClose={handleClose}
        open={open}
      >
        <Box sx={style}>
        <TransferList  list={props.rightAnexos} />

        </Box>
                  
      
      </Modal> 
      
    </div>
  );
}
export default connect(mapStateToProps, null)(CustomizedDialogs)